import { db } from "../../firebase";
import { doc, updateDoc } from "firebase/firestore";

const DeleteLead = async (leadsID) => {
  /**
   * input: null
   * output: delete lead
   * description: delete lead details
   */

  try {
    const leadDocument = await doc(db, "leads", leadsID);

    await updateDoc(leadDocument, {
      is_deleted: true,
    });
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default DeleteLead;
